<template>
  <v-flex xs12 px-3 style="padding-top: 10px !important; width: 100vw;">
    <v-flex xs12>
      <v-btn @click="gotoFrontPage" style="width: 80px;" class="breadCrumb">
        <v-icon>home</v-icon>
      </v-btn>
      <v-btn @click="deSelectMode" class="breadCrumb">
        Supplier status
      </v-btn>
      <v-btn @click="selectProductionStatus" class="breadCrumb breadCrumbWide" v-if="isProductionStatus">
        Production status
      </v-btn>
      <v-btn @click="selectLabellingReports" class="breadCrumb breadCrumbWide" v-if="isLabellingReports">
        Labelling reports
      </v-btn>
      <v-btn @click="selectDailyProduction" class="breadCrumb breadCrumbWide" v-if="isDailyProduction">
        Daily production
      </v-btn>
      <v-btn @click="selectLoadingReport" class="breadCrumb breadCrumbWide" v-if="isLoadingReport">
        Loading report
      </v-btn>
      <v-btn @click="selectDeliveryReport" class="breadCrumb breadCrumbWide" v-if="isDeliveryReport">
        Delivery report
      </v-btn>
      <div style="display: inline; float: right;">
        <v-btn @click="productionStatusExcelReport" class="btnPrintReport" v-if="isProductionStatus && productionStatusLoaded">Excel</v-btn>
        <v-btn @click="dailyProductionPdfReport" class="btnPrintReport" v-if="isDailyProduction && dailyProductionLoaded">Print</v-btn>
        <v-btn @click="dailyProductionExcelReport" class="btnPrintReport" v-if="isDailyProduction && dailyProductionLoaded">Excel</v-btn>
        <v-btn @click="labellingReportExcelReport" class="btnPrintReport" v-if="isLabellingReports && labellingReportsLoaded">Excel</v-btn>
        <v-btn @click="loadingReportExcelReport" class="btnPrintReport" v-if="isLoadingReport && loadingReceiptsLoaded">Excel</v-btn>
        <v-btn @click="deliveryReportPdfReport" class="btnPrintReport" v-if="isDeliveryReport && deliveryReportLoaded">Print</v-btn>
        <v-btn @click="deliveryReportExcelReport" class="btnPrintReport" v-if="isDeliveryReport && deliveryReportLoaded">Excel</v-btn>
      </div>
      <div style="height: 10px;"></div>
    </v-flex>
    <v-flex xs12 v-if="!isModeSelected">
      <v-flex style="width: 50%; position: absolute; top: 50%; left: 50%; transform: translateY(-50%) translateX(-50%);">
        <v-btn @click="selectProductionStatus" :style="'width: 100%; height: 13vh !important; font-size: 25pt !important; margin-bottom: 2vh !important;'">Production status</v-btn>
        <v-btn @click="selectLabellingReports" :style="'width: 100%; height: 13vh !important; font-size: 25pt !important; margin-bottom: 2vh !important;'">Labelling reports</v-btn>
        <v-btn @click="selectDailyProduction" :style="'width: 100%; height: 13vh !important; font-size: 25pt !important; margin-bottom: 2vh !important;'">Daily production</v-btn>
        <v-btn @click="selectLoadingReport" :style="'width: 100%; height: 13vh !important; font-size: 25pt !important; margin-bottom: 2vh !important;'">Loading report</v-btn>
        <v-btn @click="selectDeliveryReport" :style="'width: 100%; height: 13vh !important; font-size: 25pt !important; margin-bottom: 2vh !important;'">Delivery report</v-btn>
      </v-flex>
    </v-flex>
    <v-container fluid py-2 px-3 v-if="isProductionStatus && productionStatusLoaded">
      <v-layout style="max-height: calc(100vh - 180px);">
        <v-flex style="overflow-y: auto;">
          <table class="productionStatus">
            <tr>
              <th>Field</th>
              <th>Categories</th>
              <th style="text-align: right; padding-right: 10px; width: 120px;">Labelled</th>
              <th style="text-align: right; padding-right: 10px; width: 120px;">Planned</th>
              <th style="text-align: right; padding-right: 10px; width: 120px;">Produced</th>
              <th style="text-align: right; padding-right: 10px; width: 120px;">Progress</th>
            </tr>
            <tr v-for="(status, i) in productionStatus.fields" v-bind:key="status.field ? status.field.address.id : 0" :class="(i % 2 === 0 ? 'even' : 'odd')">
              <td class="main" v-if="status.field">
                <div v-if="status.field.address.name" style="font-weight: bold;">{{ status.field.address.name }}</div>
                {{ status.field.address.text }}
              </td>
              <td class="main" v-if="!status.field">
                &nbsp;
              </td>
              <td class="main">
                <table>
                  <tr v-for="summary in status.summaries" v-bind:key="summary.category.id">
                    <td style="white-space: nowrap;">{{ summary.category.label }}</td>
                  </tr>
                </table>
              </td>
              <td class="main" style="text-align: right; padding-right: 10px;">
                <table style="width: 100%;">
                  <tr v-for="summary in status.summaries" v-bind:key="summary.category.id">
                    <td style="white-space: nowrap;">{{ summary.labelledAmount }}</td>
                  </tr>
                </table>
              </td>
              <td class="main" style="text-align: right; padding-right: 10px;">
                <table style="width: 100%;">
                  <tr v-for="summary in status.summaries" v-bind:key="summary.category.id">
                    <td style="white-space: nowrap;">{{ summary.plannedAmount }}</td>
                  </tr>
                </table>
              </td>
              <td class="main" style="text-align: right; padding-right: 10px;">
                <table style="width: 100%;">
                  <tr v-for="summary in status.summaries" v-bind:key="summary.category.id">
                    <td style="white-space: nowrap;">{{ summary.amount }}</td>
                  </tr>
                </table>
              </td>
              <td class="main" style="text-align: right; padding-right: 10px;">
                <table style="width: 100%;">
                  <tr v-for="summary in status.summaries" v-bind:key="summary.category.id">
                    <td style="white-space: nowrap;">{{ summary.labelledAmount > 0 ? (Math.min(100, 100 * summary.amount / summary.labelledAmount).toFixed(0) + ' %') : 'N/A' }}</td>
                  </tr>
                </table>
              </td>
            </tr>
          </table>
        </v-flex>
      </v-layout>
    </v-container>
    <v-container fluid py-2 px-3 v-if="isLabellingReports && labellingReportsLoaded">
      <v-layout style="max-height: calc(100vh - 180px);">
        <v-flex style="overflow-y: auto;">
          <table class="labellingReports">
            <tr>
              <th>Category</th>
              <th>Supplier</th>
              <th>Field</th>
              <th style="text-align: right;">Amount</th>
            </tr>
            <tr v-for="(report, i) in labellingReports" v-bind:key="report.id" :class="(i % 2 === 0 ? 'even' : 'odd')">
              <td class="main"><div v-if="report.category" v-html="report.category.label"></div></td>
              <td class="main"><div v-if="report.supplier" v-html="report.supplier.name"></div></td>
              <td class="main">
                <div v-if="report.field">{{ report.field.address && report.field.address.name && report.field.address.name !== '' ? report.field.address.name : report.field.address ? report.field.address.text : '' }}</div>
              </td>
              <td class="main" style="text-align: right; padding-right: 8px;"><div v-html="report.total"></div></td>
            </tr>
          </table>
        </v-flex>
      </v-layout>
    </v-container>
    <v-container fluid py-2 px-3 v-if="isDailyProduction && dailyProductionLoaded">
      <v-layout style="max-height: calc(100vh - 180px);">
        <v-flex style="overflow-y: auto;">
          <table class="productionReport">
            <tr>
              <th>Produced</th>
              <th>By</th>
              <th>Shipment</th>
              <th>Pallet</th>
              <th>Category</th>
              <th style="text-align: right;">Amount</th>
              <th>Supplier</th>
              <th>Field</th>
            </tr>
            <template v-for="(report) in dailyProduction.dates">
              <tr v-for="(line) in report.lines" v-bind:key="line.key" :class="(report.rowIndex % 2 === 0 ? 'evenByDate' : 'oddByDate') + (report.firstInRow && line.lineIndex === 0 ? ' dateChanged' : '')">
                <td class="main">{{ report.date !== '0000-00-00 00:00' && report.date !== '9999-12-31 23:59' ? report.date : '' }}</td>
                <td class="main">{{ line.producedBy ? line.producedBy : '' }}</td>
                <td class="main">{{ line.shipmentNumber }}</td>
                <td class="main">{{ line.palletNumber }}</td>
                <td class="main"><div v-html="line.categories"></div></td>
                <td class="main" style="text-align: right; padding-right: 8px;"><div v-html="line.totalAmount"></div></td>
                <td class="main">{{ line.supplier.name }}</td>
                <td class="main">{{ line.field ? line.field.address && line.field.address.name && line.field.address.name !== '' ? line.field.address.name : line.field.address ? line.field.address.text : '' : ''}}</td>
              </tr>
            </template>
          </table>
        </v-flex>
      </v-layout>
    </v-container>
    <v-container fluid py-2 px-3 v-if="isLoadingReport && loadingReceiptsLoaded">
      <v-layout style="max-height: calc(100vh - 180px);">
        <v-flex style="overflow-y: auto;">
          <table class="loadingReceipts">
            <tr>
              <th style="width: 150px;">Loaded</th>
              <th style="width: 50px;">By</th>
              <th style="width: 100px;">Pallet</th>
              <th>Supplier</th>
              <th>Shipment</th>
              <th>License plate(s)</th>
              <th>Category</th>
              <th style="width: 50px; padding-right: 20px;">Amount</th>
              <th>Loading address</th>
              <th style="width: 150px;">Internal transport</th>
            </tr>
            <tr v-for="(receipt, i) in loadingReceipts" v-bind:key="receipt.id" :class="(i % 2 === 0 ? 'even' : 'odd')">
              <td class="main" style="white-space: nowrap;">{{ receipt.timestamp }}</td>
              <td class="main" style="white-space: nowrap;">{{ receipt.userFullName }}</td>
              <td class="main">{{ receipt.pallet.palletNumber }}</td>
              <td class="main" style="white-space: nowrap;">{{ receipt.supplier.name }}</td>
              <td class="main">{{ receipt.shipment ? receipt.shipment.number : '' }}</td>
              <td class="main" style="white-space: nowrap;">{{ receipt.shipment ? receipt.shipment.licensePlate : '' }}</td>
              <td class="main" style="white-space: nowrap;">
                <div v-for="(category, c) in receipt.categories" v-bind:key="c">{{ category }}</div>
              </td>
              <td class="main" style="text-align: right; white-space: nowrap; padding-right: 20px;">
                <div v-for="(amount, a) in receipt.amounts" v-bind:key="a">{{ amount }}</div>
              </td>
              <td class="main">{{ receipt.address && receipt.address.name && receipt.address.name !== '' ? receipt.address.name : receipt.address ? receipt.address.text : '' }}</td>
              <td class="main">{{ receipt.internalTransport ? 'Yes' : 'No' }}</td>
            </tr>
          </table>
        </v-flex>
      </v-layout>
    </v-container>
    <v-container fluid py-2 px-3 v-if="isDeliveryReport && deliveryReportLoaded">
      <v-layout style="max-height: calc(100vh - 180px);">
        <v-flex style="border: 1px solid #DDDDDD; border-radius: 3px; overflow-y: auto;">
          <v-data-table :headers="deliveryReportHeaders" :items="deliveryReport.items" hide-actions class="deliveryReportTable">
            <template v-slot:items="props">
              <tr>
                <td class="text-xs-left" style="width: 20px; padding-left: 8px !important; padding-right: 0 !important; padding-top: 4px !important; padding-bottom: 0 !important;">
                  <div v-if="props.item.category && props.item.category.color && !(props.item.category.color.secondColor && props.item.category.color.secondColor !== '')" :style="'margin: 3px 5px 3px 2px; border-radius: 3px; border: 1px solid #BBBBBB; width: 16px; height: 16px; background-color: #' + props.item.category.color.color + ';'"></div>
                  <div v-if="props.item.category && props.item.category.color && props.item.category.color.secondColor && props.item.category.color.secondColor !== ''" :style="'margin: 3px 5px 3px 2px; border-radius: 3px; border: 1px solid #BBBBBB; width: 16px; height: 16px; background: repeating-linear-gradient(-45deg, #' + props.item.category.color.color + ', #' + props.item.category.color.color + ' 3px, #' + props.item.category.color.secondColor + ' 3px, #' + props.item.category.color.secondColor + ' 6px);'"></div>
                  <div v-if="!props.item.category">&nbsp;</div>
                </td>
                <td class="text-xs-left" style="padding-top: 4px !important;">
                  <div v-if="props.item.category">{{ props.item.category.displayLabel }}</div>
                  <div v-if="!props.item.category" style="font-weight: bold;">Total</div>
                </td>
                <td class="text-xs-right" style="padding-top: 4px !important;">
                  <div :style="props.item.category ? '' : 'font-weight: bold;'">{{ props.item.amount.toLocaleString() }}</div>
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-flex>
      </v-layout>
    </v-container>

    <ErrorDialog ref="errorDialog"/>
  </v-flex>
</template>

<script>
import Panel from '../components/Panel'
import LoaderPallet from '../components/LoaderPallet'
import PanelColumn from '../components/PanelColumn'
import ErrorDialog from '../components/ErrorDialog'
import DateUtil from '@/assets/javascript/dateutil'
import axios from 'axios'
import uuid from 'uuid/v4'

export default {
  name: 'SupplierStatus',
  components: { Panel, LoaderPallet, PanelColumn, ErrorDialog },
  data () {
    return {
      productionStatus: [],
      productionStatusLoaded: false,
      labellingReports: null,
      labellingReportsLoaded: false,
      loadingReceipts: null,
      loadingReceiptsLoaded: false,
      dailyProduction: null,
      dailyProductionLoaded: false,
      deliveryReport: null,
      deliveryReportLoaded: false,
      mode: null,
      deliveryReportHeaders: [
        { text: '', sortable: false },
        { text: 'Category', value: 'category.displayLabel', sortable: false },
        { text: 'Amount', value: 'amount', sortable: false, align: 'right' }
      ]
    }
  },
  created: function () {
    this.deSelectMode()
  },
  computed: {
    isModeSelected: function () {
      return this.mode !== null
    },
    isProductionStatus: function () {
      return this.mode === 'PRODUCTION_STATUS'
    },
    isDailyProduction: function () {
      return this.mode === 'DAILY_PRODUCTION'
    },
    isLabellingReports: function () {
      return this.mode === 'LABELLING_REPORTS'
    },
    isLoadingReport: function () {
      return this.mode === 'LOADING_REPORT'
    },
    isDeliveryReport: function () {
      return this.mode === 'DELIVERY_REPORT'
    }
  },
  methods: {
    gotoFrontPage: function () {
      this.$parent.$parent.gotoHome()
    },
    deSelectMode () {
      this.mode = null
    },
    selectProductionStatus () {
      this.mode = 'PRODUCTION_STATUS'
      this.loadProductionStatus()
    },
    selectDailyProduction () {
      this.mode = 'DAILY_PRODUCTION'
      this.loadDailyProduction()
    },
    selectLabellingReports () {
      this.mode = 'LABELLING_REPORTS'
      this.loadLabellingReports()
    },
    selectLoadingReport () {
      this.mode = 'LOADING_REPORT'
      this.loadLoadingReceipts()
    },
    selectDeliveryReport () {
      this.mode = 'DELIVERY_REPORT'
      this.loadDeliveryReport()
    },
    loadProductionStatus () {
      this.productionStatus = []
      this.productionStatusLoaded = false
      axios.get('/backend/rest/production_status')
        .then(response => {
          this.productionStatus = response.data
          this.productionStatusLoaded = true
        })
    },
    loadDailyProduction () {
      this.dailyProductionLoaded = false
      axios.get('/backend/rest/production_report/supplier')
        .then(response => {
          this.dailyProduction = response.data
          this.dailyProductionLoaded = true
        })
    },
    loadLabellingReports () {
      this.labellingReportsLoaded = false
      axios.get('/backend/rest/label_report/supplier')
        .then(response => {
          this.labellingReports = response.data
          this.labellingReportsLoaded = true
        })
    },
    loadLoadingReceipts () {
      this.loadingReceiptsLoaded = false
      axios.get('/backend/rest/pallet_loading_receipt/supplier')
        .then(response => {
          this.loadingReceipts = response.data
          this.loadingReceiptsLoaded = true
        })
    },
    loadDeliveryReport () {
      this.deliveryReportLoaded = false
      axios.get('/backend/rest/delivery_report')
        .then(response => {
          this.deliveryReport = response.data
          if (this.deliveryReport && this.deliveryReport.items) {
            let total = 0
            for (let item of this.deliveryReport.items) {
              total += item.amount
            }
            this.deliveryReport.items.push({
              category: null,
              amount: total
            })
          }
          this.deliveryReportLoaded = true
        })
    },
    formatDatetime (date) {
      return DateUtil.datetimeToString(date)
    },
    categories: function (pallet) {
      let categories = ''
      if (pallet.items) {
        let items = pallet.items
        for (let item of items) {
          if (categories.length > 0) {
            categories += '<br/>'
          }
          categories += (item.category ? item.category.label : item.categoryName)
          categories += ', ' + item.plannedAmount + 'pcs.'
        }
      }
      return categories
    },
    productionStatusExcelReport () {
      let url = '/backend/report/supplierStatus&uuid=' + uuid()
      window.open(url)
    },
    dailyProductionPdfReport () {
      let url = '/backend/print/supplierProductionReportByDate.xhtml?uuid=' + uuid()
      window.open(url)
    },
    dailyProductionExcelReport () {
      let url = '/backend/report/productionReport/supplier&uuid=' + uuid()
      window.open(url)
    },
    labellingReportExcelReport () {
      let url = '/backend/report/labelReport/supplier&uuid=' + uuid()
      window.open(url)
    },
    loadingReportExcelReport () {
      let url = '/backend/report/loadingReport/supplier&uuid=' + uuid()
      window.open(url)
    },
    deliveryReportPdfReport () {
      let url = '/backend/print/deliveryReport.xhtml?title=Delivery report&uuid=' + uuid()
      window.open(url)
    },
    deliveryReportExcelReport () {
      let url = '/backend/report/deliveryReport&uuid=' + uuid()
      window.open(url)
    }
  }
}
</script>

<style scoped>
  button {
    margin-left: 0 !important;
    margin-right: 0 !important;
  }
  .v-btn {
    border-radius: 12px;
  }
  .v-btn .v-btn__content {
  }
  table.productionStatus {
    width: 100%;
    border-collapse: collapse;
    padding-left: 10px;
    padding-right: 10px;
  }
  table.productionStatus th {
    text-align: left;
    border-bottom: 1px solid #004d40;
    padding: 2px 5px;
  }
  table.productionStatus td.main {
    vertical-align: top;
    border-bottom: 1px solid #D0D0D0;
    padding: 2px 5px;
  }
  table.productionReport {
    width: 100%;
    border-collapse: collapse;
    padding-left: 10px;
    padding-right: 10px;
  }
  table.productionReport th {
    text-align: left;
    border-bottom: 1px solid #004d40;
    padding: 2px 5px;
  }
  table.productionReport td.main {
    vertical-align: top;
    border-bottom: 1px solid #D0D0D0;
    padding: 2px 5px;
  }
  table.labellingReports,
  table.loadingReceipts {
    width: 100%;
    border-collapse: collapse;
    padding-left: 10px;
    padding-right: 10px;
  }
  table.labellingReports th,
  table.loadingReceipts th {
    text-align: left;
    border-bottom: 1px solid #004d40;
    padding: 2px 5px;
  }
  table.labellingReports td,
  table.loadingReceipts td {
    vertical-align: top;
    border-bottom: 1px solid #D0D0D0;
    padding: 2px 5px;
  }
  tr.odd {
    background-color: #ffffff;
  }
  tr.even {
    background-color: rgba(0, 77, 64, 0.02);
  }
  tr.oddByDate {
    background-color: rgba(0, 77, 64, 0.02);
  }
  tr.evenByDate {
    background-color: #ffffff;
  }
  tr.dateChanged {
    border-top: 2px solid #303030 !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/SupplierStatus.vue